export default __webpack_public_path__ + "static/media/cardio2.565e5668.jpg";